import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import { RemittanceReturnProtocolRequest } from '@/core/domain/financial/Boletos/Boletos.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import { useEffect } from 'react';

export interface ConsultFileFormValues {
  companyId: number;
  protocol: string;
}

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: () => void;
  companyId?: number;
  onCallback: (values: RemittanceReturnProtocolRequest) => void;
  loading?: boolean;
};

export default function BankSlipConsultFileModal({
  onCancel,
  companyId,
  onCallback,
  loading,
  ...props
}: Props) {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const [form] = Form.useForm<ConsultFileFormValues>();

  function handleCancel() {
    form.resetFields();

    onCancel();
  }

  const handleOk = async () => {
    const values = await form.validateFields();

    await onCallback({ ...values });

    handleCancel();
  };

  useEffect(() => {
    if (companyId) {
      form.setFieldValue('companyId', companyId);
    }
  }, [props.open]);

  return (
    <Modal
      {...props}
      width={400}
      onOk={handleOk}
      onCancel={handleCancel}
      title="Consulta do processamento de retorno"
      cancelText="Cancelar"
      okText="Consultar"
      confirmLoading={loading}
    >
      {loading && (
        <ModalLoadingOverlay messages={['Consultando protocolo...']} />
      )}

      <Form form={form}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <FloatingFormItem
              name="protocol"
              label="Protocolo"
              rules={[defaultEmptyFieldError]}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem label="Empresa" name="companyId">
              <CompaniesInfiniteSelectField disabled />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
